import script from "./popup-detail-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./popup-detail-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__